import { Box, Grid, Typography, Button } from '@mui/material';
import { conversionFactors } from '../constants/button-selection-constants';

/**
 * @param {Object} props
 * @param {string[]} props.years Years array that comes from the backend
 * @param {string} props.selectedYear 
 * @param {(clickedButton: string | string[] | {id: number, name: string} | {id: number, name: string, facilities: {id: number, name: string}[]} | {name: string, categories: Array<string>}) => void} props.handleOnClick
 * @returns {JSX.Element}
 */
export function YearSelection({ years, selectedYear, handleOnClick }) {
    return (
        <Grid container item xs={12} sx={{ gap: 1 }}>
            <Grid item xs={12}>
                <Typography variant='h6' component='h6'>
                    {selectedYear
                        ? `Year: ${selectedYear}`
                        : 'Year: Select Year'}</Typography>
            </Grid>
            <Grid container item spacing={2} xs={12}>
                {years?.map((year, index) => (
                    <Grid item key={index}>
                        <Button
                            variant={year === selectedYear ? 'contained' : 'outlined'}
                            onClick={() => {
                                handleOnClick(year)
                            }}
                        >
                            {year}
                        </Button>
                    </Grid>
                ))}
            </Grid>
        </Grid>
    )
}

/**
 * @param {Object} props
 * @param {{id: number, name: string}} props.company
 * @param {{id: number, name: string}} props.selectedCompany 
 * @param {(clickedButton: string | string[] | {id: number, name: string} | {id: number, name: string, facilities: {id: number, name: string}[]} | {name: string, categories: Array<string>}) => void} props.handleOnClick
 * @returns {JSX.Element}
 */
export function CompanySelection({ company, selectedCompany, handleOnClick }) {
    return (
        <Grid container item xs={12} sx={{ gap: 1 }}>
            <Grid item xs={12}>
                <Typography variant='h6' component='h6'>
                    {selectedCompany
                        ? `Company: ${selectedCompany?.name}`
                        : 'Company: Select Company'}</Typography>
            </Grid>
            <Grid container item spacing={2} xs={12}>
                <Grid item>
                    <Button
                        variant={company?.name === selectedCompany?.name ? 'contained' : 'outlined'}
                        onClick={() => handleOnClick(company)}
                    >
                        {company?.name}
                    </Button>
                </Grid>
            </Grid>
        </Grid>
    )
}

/**
 * @param {Object} props
 * @param {{id: number, name: string}[]} props.groups Array of groups coming from the backend
 * @param {{id: number, name: string}} props.selectedGroup 
 * @param {(clickedButton: string | string[] | {id: number, name: string} | {id: number, name: string, facilities: {id: number, name: string}[]} | {name: string, categories: Array<string>}) => void} props.handleOnClick
 * @returns {JSX.Element}
 */
export function GroupSelection({ groups, selectedGroup, handleOnClick }) {
    console.log(groups, 'groupies')
    return (
        <Grid container item xs={12} sx={{ gap: 1 }}>
            <Grid item xs={12}>
                <Typography variant='h6' component='h6'>
                    {selectedGroup
                        ? `Group: ${selectedGroup?.name}`
                        : 'Group: Select Group'}</Typography>
            </Grid>
            <Grid container item spacing={2} xs={12}>
                {groups.map((group, index) => (
                    <Grid item key={index}>
                        <Button
                            variant={group?.name === selectedGroup?.name ? 'contained' : 'outlined'}
                            onClick={() => {
                                handleOnClick(group);

                            }}
                        >
                            {group.name}
                        </Button>
                    </Grid>
                ))}
            </Grid>
        </Grid>
    )
}

/**
 * @param {Object} props
 * @param {{id: number, name: string}} props.selectedGroup 
 * @param {{id: number, name: string}} props.selectedFacility 
 * @param {(clickedButton: string | string[] | {id: number, name: string} | {id: number, name: string, facilities: {id: number, name: string}[]} | {name: string, categories: Array<string>}) => void} props.handleOnClick
 * @returns {JSX.Element}
 */
export function FacilitySelection({ selectedGroup, selectedFacility, handleOnClick }) {
    const facilities = selectedGroup.facilities

    return (
        <Grid container item xs={12} sx={{ gap: 1 }}>
            <Grid item xs={12}>
                <Typography variant='h6' component='h6'>
                    {selectedFacility
                        ? `Facility: ${selectedFacility?.name}`
                        : 'Facility: Select Facility'}</Typography>
            </Grid>
            <Grid container item spacing={2} xs={12}>
                {facilities?.map((facility, index) => (
                    <Grid item key={index}>
                        <Button
                            variant={facility?.name === selectedFacility?.name ? 'contained' : 'outlined'}
                            onClick={() => {
                                handleOnClick(facility);
                            }}
                        >
                            {facility?.name}
                        </Button>
                    </Grid>
                ))}
            </Grid>
        </Grid>
    )
}

/**
 * @param {Object} props
 * @param {Array<{name: string, categories: string[]}>} props.categories Accepted as prop because filtering logic must be applied
 * @param {{name: string, categories: Array<string>}} props.selectedCategory 
 * @param {(clickedButton: string | string[] | {id: number, name: string} | {id: number, name: string, facilities: {id: number, name: string}[]} | {name: string, categories: Array<string>}) => void} props.handleOnClick
 * @returns {JSX.Element}
 */
export function CategorySelection({ categories, selectedCategory, handleOnClick }) {
    return (
        <Grid container item xs={12} sx={{ gap: 1 }}>
            <Grid item xs={12}>
                <Typography variant='h6' component='h6'>
                    {selectedCategory
                        ? `Category: ${selectedCategory.name}`
                        : 'Category: Select Category'}</Typography>
            </Grid>
            <Grid container item spacing={2} xs={12}>
                {categories?.map((category, index) => (
                    <Grid item key={index}>
                        <Button
                            variant={category?.name === selectedCategory?.name ? 'contained' : 'outlined'}
                            onClick={() => {
                                handleOnClick(category);
                            }}
                        >
                            {category?.name}
                        </Button>
                    </Grid>
                ))}
            </Grid>
        </Grid>
    )
}

/**
 * @param {Object} props
 * @param {Array<string>} props.categories Accepted as prop because filtering logic must be applied
 * @param {string} props.selectedDataCapturingCategory 
 * @param {(clickedButton: string | string[] | {id: number, name: string} | {id: number, name: string, facilities: {id: number, name: string}[]} | {name: string, categories: Array<string>}) => void} props.handleOnClick
 * @returns {JSX.Element}
 */
export function DataCapturingCategorySelection({ categories, selectedDataCapturingCategory, handleOnClick }) {
    return (
        <Box>
            {categories.map((dataCapturingCategory, index) => (
                <Button key={index}
                    variant={dataCapturingCategory === selectedDataCapturingCategory ? 'contained' : 'outlined'}
                    sx={{ width: '100%', mb: 2 }}
                    onClick={() => {
                        handleOnClick(dataCapturingCategory);
                    }}
                >
                    {dataCapturingCategory}
                </Button>
            ))}
        </Box>
    )
}

/**
 * @param {Object} props
 * @param {Array<string>} props.generalInformationOptions Accepted as prop because filtering logic must be applied
 * @param {string} props.selectedGeneralInformationOption 
 * @param {(clickedButton: string | string[] | {id: number, name: string} | {id: number, name: string, facilities: {id: number, name: string}[]} | {name: string, categories: Array<string>}) => void} props.handleOnClick
 * @returns {JSX.Element}
 */
export function GeneralInformationSelection({ generalInformationOptions, selectedGeneralInformationOption, handleOnClick }) {
    return (
        <Grid container item xs={12} sx={{ gap: 1 }}>
            <Grid item xs={12}>
                <Typography variant='h6' component='h6'>
                    {selectedGeneralInformationOption
                        ? `Information: ${selectedGeneralInformationOption}`
                        : 'Information: Select Option'}</Typography>
            </Grid>
            <Grid container item spacing={2} xs={12}>
                {generalInformationOptions?.map((generalInformationOption, index) => (
                    <Grid item key={index}>
                        <Button
                            variant={generalInformationOption === selectedGeneralInformationOption ? 'contained' : 'outlined'}
                            onClick={() => handleOnClick(generalInformationOption)}
                        // disabled={generalInformationOption === 'Agrochemical List' || generalInformationOption === 'Fertilizer List'}
                        >
                            {generalInformationOption}
                        </Button>
                    </Grid>
                ))}
            </Grid>
        </Grid>
    )
}

/**
 * @param {Object} props
 * @param {string} props.selectedConversionFactor 
 * @param {(clickedButton: string | string[] | {id: number, name: string} | {id: number, name: string, facilities: {id: number, name: string}[]} | {name: string, categories: Array<string>}) => void} props.handleOnClick
 * @returns {JSX.Element}
 */
export function ConversionFactorSelection({ selectedConversionFactor, handleOnClick }) {
    return (
        <Grid container item xs={12} sx={{ gap: 1 }}>
            <Grid item xs={12}>
                <Typography variant='h6' component='h6'>
                    {selectedConversionFactor
                        ? `Conversion Factor: ${selectedConversionFactor}`
                        : 'Conversion Factor: Select Factor'}</Typography>
            </Grid>
            <Grid container item spacing={2} xs={12}>
                {conversionFactors?.map((factor, index) => (
                    <Grid item key={index}>
                        <Button
                            variant={factor === selectedConversionFactor ? 'contained' : 'outlined'}
                            onClick={() => {
                                handleOnClick(factor);
                            }}>
                            {factor}
                        </Button>
                    </Grid>
                ))}
            </Grid>
        </Grid>
    )
}

/** unused abstracted component to unify the selection buttons
 * @param {Object} props
 * @param {"Year" | "Company" | "Group" | "Facility" | "Category" | "Data Capturing Category" | "Conversion Factor" | "Information"} props.type
 * @param {Array<string>} props.array 
 * @param {string | {id: number, name: string} | {name: string, categories: Array<string>}} props.selected 
 * @param {(clickedButton: string | string[] | {id: number, name: string} | {id: number, name: string, facilities: {id: number, name: string}[]} | {name: string, categories: Array<string>}) => void} props.handleOnClick
 * @returns {JSX.Element}
 */
export function SelectionButtons({ type, array, selected, handleOnClick }) {
    const selectedItem = selected?.name ? selected.name : selected
    return (
        <Grid container item xs={12} sx={{ gap: 1 }}>
            <Grid item xs={12}>
                <Typography variant='h6' component='h6'>
                    {selectedItem
                        ? `${type}: ${selectedItem}`
                        : `${type}: Select ${type}`}</Typography>
            </Grid>
            <Grid container item spacing={2} xs={12}>
                {array.map((arrayItem, index) => {
                    const item = arrayItem?.name ? arrayItem.name : arrayItem
                    return (
                        <Grid item key={index}>
                            <Button
                                variant={item === selectedItem ? 'contained' : 'outlined'}
                                onClick={() => {
                                    handleOnClick(arrayItem);
                                }}
                            >
                                {item}
                            </Button>
                        </Grid>
                    )
                })}
            </Grid>
        </Grid>
    )
}